import React, { useState } from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Question from "./Question";

//material UI
import { Button } from "@material-ui/core";
import { CircularProgress } from "@material-ui/core";

import description from "./description";

// Answers
import Answers from "./Answers";

import results from "./results";

// for the map, test
import data from "./data";
import createCard from "./createCard";

const [OneOne, OneTwo, OneThree] = description[0];
const [TwoOne, TwoTwo, TwoThree] = description[1];
const [ThreeOne, ThreeTwo, ThreeThree] = description[2];

function Questions(props) {
  // button style change
  const [style, setStyle] = useState("primary");
  const [altStyle, setAltStyle] = useState("default");

  // Show answers
  const [show, setShow] = useState(false);

  // function handleClick(event) {
  //   console.log(event.target.innerText);
  // }

  // WORKING*** sending data to App.js**
  const [submitted, setSubmitted] = useState(false);

  // WORKING****
  var [customStyle, changeStyle] = useState("primary");

  function addStyle() {
    customStyle === "primary" ? changeStyle("light") : changeStyle("primary");
  }
  // WORKING****
  // good that it starts on null because no styling is applied to the buttons
  var [answers, setAnswers] = useState({
    QUESTION1: null,
    QUESTION2: null,
    QUESTION3: null
  });

  // 3 seperate handle clicks because I cant get out anything
  // other than the innerHTML !!!!!
  // can get rid of other destucturing name, value, id.. leave for now

  function handleClickQ1(event, props) {
    // console.log(event.target.id);
    // console.log(event.target.name);
    const { name, value, innerText, id } = event.target;
    const optionQuestion1 = "QUESTION1";
    setSubmitted(false);
    setAnswers(prevAnswers => {
      return {
        ...prevAnswers,
        [optionQuestion1]: innerText
      };
    });
  }

  function handleClickQ2(event) {
    // console.log(event.target.id);
    // console.log(event.target.name);
    const { name, value, innerText, id } = event.target;
    const optionQuestion2 = "QUESTION2";
    setSubmitted(false);
    setAnswers(prevAnswers => {
      return {
        ...prevAnswers,
        [optionQuestion2]: innerText
      };
    });
  }

  function handleClickQ3(event) {
    // console.log(event.target.id);
    // console.log(event.target.name);
    const { name, value, innerText, id } = event.target;
    const optionQuestion3 = "QUESTION3";
    setSubmitted(false);
    setAnswers(prevAnswers => {
      return {
        ...prevAnswers,
        [optionQuestion3]: innerText
      };
    });
  }

  // console.log(answers);

  // Answers...

  // answers.QUESTION1 === null ||
  // answers.QUESTION2 === null ||
  // answers.QUESTION3 === null
  //   ? console.log("all not answered")
  //   : console.log("all answered");

  // answers.QUESTION1 === "OPTION 1" ? changeDescriptionOne('yes') : changeDescriptionOne(null);

  // conditional rendering on the button styling linked to a stateful database

  // note that the buttons turn the characters into capitals automatically

  // option string is used in multiple place for each, could restructure to
  // make a variable for each, this way when one changes, they all do,
  // less room for error..[]

  const [resultText, updateResultText] = useState("no result");

  const [resultTextType, updateResultTextType] = useState("no result");

  // conditionally logs yes/ no depending on what description is
  // this needs to become the brain
  // gives an answer based on the results selected
  // **need a delay of about 3 seconds to mimic processing

  // console.log(resultText);
  // console.log(resultTextType);

  function printResult() {
    // Currently works on first 2 options only
    // last option should be irrelevant, ie give advice on type
    answers.QUESTION1 === "DRY" && answers.QUESTION2 === "DRY"
      ? filterObjectAlt("1 and 1")
      : console.log(null);
    answers.QUESTION1 === "DRY" && answers.QUESTION2 === "NORMAL"
      ? filterObjectAlt("1 and 2")
      : console.log(null);
    answers.QUESTION1 === "DRY" && answers.QUESTION2 === "OILY"
      ? filterObjectAlt("1 and 3")
      : console.log(null);
    answers.QUESTION1 === "NORMAL" && answers.QUESTION2 === "DRY"
      ? filterObjectAlt("2 and 1")
      : console.log(null);
    answers.QUESTION1 === "NORMAL" && answers.QUESTION2 === "NORMAL"
      ? filterObjectAlt("2 and 2")
      : console.log(null);
    answers.QUESTION1 === "NORMAL" && answers.QUESTION2 === "OILY"
      ? filterObjectAlt("2 and 3")
      : console.log(null);
    answers.QUESTION1 === "OILY" && answers.QUESTION2 === "DRY"
      ? filterObjectAlt("3 and 1")
      : console.log(null);
    answers.QUESTION1 === "OILY" && answers.QUESTION2 === "NORMAL"
      ? filterObjectAlt("3 and 2")
      : console.log(null);
    answers.QUESTION1 === "OILY" && answers.QUESTION2 === "OILY"
      ? filterObjectAlt("3 and 3")
      : console.log(null);

    answers.QUESTION3 === "WAVY"
      ? updateResultTextType(results[0].result)
      : console.log(null);
    answers.QUESTION3 === "CURLY"
      ? updateResultTextType(results[1].result)
      : console.log(null);
    answers.QUESTION3 === "COILY"
      ? updateResultTextType(results[2].result)
      : console.log(null);
  }

  // don't think I really need these...
  // it's purpose before was to send data over to app
  // everything is handled in here now..
  // const [answersOne, setAnswersOne] = useState();
  // const [answersTwo, setAnswersTwo] = useState();

  // function onSend(resultText, resultTextType) {
  //   console.log("data...");
  //   console.log("received......" + resultText);
  //   console.log("received......" + resultTextType);
  //   setAnswersOne(resultText);
  //   setAnswersTwo(resultTextType);
  //   console.log(resultText);
  //   console.log(resultTextType);
  // }

  // unbiased shuffle algorithm - Fisher-Yates (aka Knuth) Shuffle
  function shuffle(array) {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

  // filtering the results...
  const [dataFilterAlt, setDataFilterAlt] = useState();

  function filterObjectAlt(input) {
    var newData = [];
    for (var j of data) {
      for (var k of j.option) {
        if (k === input) {
          newData.push(j);
        } else {
          console.log("nothing pushed");
        }
      }
    }
    // console.log("set DataFilterAlt....");
    // setDataFilterAlt(newData);
    setDataFilterAlt(shuffle(newData));
  }
  // console.log("data filter...", dataFilterAlt);
  // filtering the results***

  // loading symbol
  // loading symbol display
  const [isTraining, updateIsTraining] = useState(false);
  // loading symbol time gets quicker if loaded previously
  const [previouslyTrained, setPreviouslyTrained] = useState(false);

  // function loading() {
  //   updateIsTraining(true);
  //   console.log("loading");

  //   setTimeout(function() {
  //     updateIsTraining(false);
  //     setShow(true);
  //     setSubmitted(true);
  //     printResult();
  //   }, 950);

  //   console.log("finished loading");
  // }

  return (
    <div className="Questions">
      <h3>Questions</h3>
      <Question
        optionQuestion="What best describes your hair?"
        optionOne="DRY"
        optionTwo="NORMAL"
        optionThree="OILY"
        optionOneStyling={answers.QUESTION1 === "DRY" ? style : altStyle}
        optionTwoStyling={answers.QUESTION1 === "NORMAL" ? style : altStyle}
        optionThreeStyling={answers.QUESTION1 === "OILY" ? style : altStyle}
        onClick={handleClickQ1}
        textStyle={answers.QUESTION1 === null ? { color: "lightgrey" } : null}
        optionDescription={
          answers.QUESTION1 === null
            ? "*click one of the options above*"
            : answers.QUESTION1 === "DRY"
            ? OneOne.description
            : answers.QUESTION1 === "NORMAL"
            ? OneTwo.description
            : answers.QUESTION1 === "OILY"
            ? OneThree.description
            : null
        }
      />
      <Question
        optionQuestion="What best describes your scalp?"
        optionOne="DRY"
        optionTwo="NORMAL"
        optionThree="OILY"
        optionOneStyling={answers.QUESTION2 === "DRY" ? style : altStyle}
        optionTwoStyling={answers.QUESTION2 === "NORMAL" ? style : altStyle}
        optionThreeStyling={answers.QUESTION2 === "OILY" ? style : altStyle}
        onClick={handleClickQ2}
        textStyle={answers.QUESTION2 === null ? { color: "lightgrey" } : null}
        optionDescription={
          answers.QUESTION2 === null
            ? "*click one of the options above*"
            : answers.QUESTION2 === "DRY"
            ? TwoOne.description
            : answers.QUESTION2 === "NORMAL"
            ? TwoTwo.description
            : answers.QUESTION2 === "OILY"
            ? TwoThree.description
            : null
        }
      />
      <Question
        optionQuestion="What is your hair type?"
        optionOne="WAVY"
        optionTwo="CURLY"
        optionThree="COILY"
        optionOneStyling={answers.QUESTION3 === "WAVY" ? style : altStyle}
        optionTwoStyling={answers.QUESTION3 === "CURLY" ? style : altStyle}
        optionThreeStyling={answers.QUESTION3 === "COILY" ? style : altStyle}
        onClick={handleClickQ3}
        textStyle={answers.QUESTION3 === null ? { color: "lightgrey" } : null}
        optionDescription={
          answers.QUESTION3 === null
            ? "*click one of the options above*"
            : answers.QUESTION3 === "WAVY"
            ? ThreeOne.description
            : answers.QUESTION3 === "CURLY"
            ? ThreeTwo.description
            : answers.QUESTION3 === "COILY"
            ? ThreeThree.description
            : null
        }
      />
      {/* <Button variant="contained" color="secondary" onClick={loading}>
        loading test
      </Button> */}
      {/* <Button
        color="secondary"
        variant="contained"
        onClick={() => filterObjectAlt(resultText)}
      >
        test submit
      </Button> */}

      <Button
        className="submitButton"
        variant="contained"
        color="primary"
        size="large"
        onClick={() => {
          updateIsTraining(true);

          console.log("loading");

          setTimeout(
            function() {
              // turn off loading symbol
              updateIsTraining(false);
              //show the answer section**
              setShow(true);
              // disables the submit button**
              setSubmitted(true);
              // sets and prints result of selection**
              // printResult();
            },
            previouslyTrained === false ? 950 : 450
          );
          setPreviouslyTrained(true);
          console.log("finished loading");

          // sets and prints result of selection**
          printResult();
        }}
        disabled={
          answers.QUESTION1 === null ||
          answers.QUESTION2 === null ||
          answers.QUESTION3 === null ||
          submitted === true
            ? true
            : false
        }
      >
        SUBMIT
      </Button>

      {/* <p>{isTraining === true ? "Loading" : null}</p> */}
      <div className="Loading">
        {isTraining === true ? (
          <CircularProgress color="primary" size="1.5rem" thickness="5" />
        ) : null}
      </div>

      {show === true ? (
        <Answers
          // answerData={resultText}
          // answerTypeData={resultTextType}
          resultDescription={resultTextType}
          // result={data.map(createCard)}
          result={dataFilterAlt.map(createCard)}
        />
      ) : null}
    </div>
  );
}

// we need result to send a function that we can use to input
// our own calues for the filter...

export default Questions;
